import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateOperatingStateDemand',
})
export class TranslateOperatingStateDemandPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.OPERATING_STATE_DEMAND[value]) {
      return this.translateService.instant(
        this.customTranslationsService.OPERATING_STATE_DEMAND[value] ?? value
      );
    }

    return value;
  }
}
